/**
 * useApiCache - gedeelde client-side fetch cache
 *
 * Module-level Map: wordt gedeeld door alle component-instanties binnen
 * één browser-sessie. Zo hoeft een pagina die net bezocht is nooit opnieuw
 * te fetchen zolang de TTL niet verlopen is.
 *
 * Server-side (SSR) wordt de cache NIET gebruikt - daar zorgt server.js
 * voor caching.
 */

const _cache = new Map()

/**
 * cachedFetch(url, ttlMs?)
 * Hetzelfde als fetch(url).then(r=>r.json()) maar met TTL-cache.
 *
 * @param {string} url
 * @param {number} ttlMs  Cache-duur in milliseconden (standaard 10 min)
 * @returns {Promise<any>}
 */
export async function cachedFetch(url, ttlMs = 10 * 60 * 1000) {
  // SSR: nooit cachen - server.js heeft zijn eigen cache
  if (typeof window === 'undefined') {
    const res = await fetch(url)
    if (!res.ok) throw new Error(`HTTP ${res.status}: ${url}`)
    return res.json()
  }

  const cached = _cache.get(url)
  if (cached && Date.now() < cached.expires) {
    return cached.data
  }

  const res = await fetch(url)
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${url}`)
  const data = await res.json()

  _cache.set(url, { data, expires: Date.now() + ttlMs })
  return data
}

/**
 * invalidateCache(urlPrefix?)
 * Verwijder entries uit de cache (handig na cart-mutaties).
 * Zonder argument: verwijder alles.
 */
export function invalidateCache(urlPrefix = '') {
  if (!urlPrefix) { _cache.clear(); return }
  for (const key of _cache.keys()) {
    if (key.startsWith(urlPrefix)) _cache.delete(key)
  }
}
